



import { InjectionToken, TemplateRef, Type } from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

export type MwcEmptySize = 'normal' | 'small' | '';

export type MwcEmptyCustomContent = Type<MwcSafeAny> | TemplateRef<MwcSafeAny> | string;

export const NZ_EMPTY_COMPONENT_NAME = new InjectionToken<string>('mwc-empty-component-name');
